module.exports = __webpack_public_path__ + "static/media/logo_mobile.c9286afa.png";